import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "onChange", "onBlur", "defaultValue", "min", "max", "decimalDigits"];
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useControlled } from '../../../../internal/hooks';
import { IMaskInput } from '../../../../internal/components/IMaskInput';
import { THOUSAND_DELIMITER, FRACTIONAL_DELIMITER } from '../../../../internal/constants/number';
export var NativeNumberInput = /*#__PURE__*/React.forwardRef(function NativeNumberInput(props, ref) {
  var as = props.as,
    onChange = props.onChange,
    onBlur = props.onBlur,
    defaultValue = props.defaultValue,
    min = props.min,
    max = props.max,
    _props$decimalDigits = props.decimalDigits,
    decimalDigits = _props$decimalDigits === void 0 ? 0 : _props$decimalDigits,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue !== undefined ? defaultValue : undefined
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var _React$useState = React.useState(toStringInputValue(value)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inputValue = _React$useState2[0],
    setInputValue = _React$useState2[1];
  var options = React.useMemo(function () {
    return {
      mask: Number,
      thousandsSeparator: THOUSAND_DELIMITER,
      radix: FRACTIONAL_DELIMITER,
      signed: isSignedRange(min),
      scale: decimalDigits
    };
  }, [min, decimalDigits]);
  useIsomorphicLayoutEffect(function () {
    setInputValue(toStringInputValue(value));
  }, [value]);
  var handleInputAccept = useEventCallback(function (eventValue) {
    setInputValue(eventValue);
    var nextValue = toNumberValue(eventValue, min, max);
    setValue(nextValue);
    if (onChange && nextValue !== value) {
      onChange(nextValue);
    }
  });
  var handleBlur = function handleBlur(e) {
    if (onBlur) {
      onBlur(e);
    }
    var finalValue = toNumberValue(inputValue, min, max);
    setInputValue(toStringInputValue(finalValue));
    if (onChange && value !== finalValue) {
      onChange(finalValue);
    }
  };
  return /*#__PURE__*/React.createElement(IMaskInput, _extends({}, rest, {
    ref: ref,
    as: as,
    type: "tel",
    onBlur: handleBlur,
    value: inputValue,
    options: options,
    onAccept: handleInputAccept,
    onComplete: handleInputAccept,
    preventActiveUpdate: true
  }));
});
function toNumberValue(inputValue, min, max) {
  return normalizeValue(inputValue !== '' ? Number(inputValue) : undefined, min, max);
}
function normalizeValue(value, min, max) {
  if (value == null) {
    return value;
  }
  var nextValue = value;
  if (min != null) {
    nextValue = Math.max(min, nextValue);
  }
  if (max != null) {
    nextValue = Math.min(max, nextValue);
  }
  return nextValue;
}
function toStringInputValue(value) {
  if (typeof value === 'number') {
    return value.toString();
  }
  return '';
}
function isSignedRange(min) {
  if (min != null) {
    return min < 0;
  }
  return true;
}